import { render, staticRenderFns } from "./UnderRepairCar.vue?vue&type=template&id=36059b4c&scoped=true"
import script from "./UnderRepairCar.vue?vue&type=script&lang=js"
export * from "./UnderRepairCar.vue?vue&type=script&lang=js"
import style0 from "./UnderRepairCar.vue?vue&type=style&index=0&id=36059b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36059b4c",
  null
  
)

export default component.exports